import * as React from 'react'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next'

interface IPopupDialog {
  label?: string
  disabled?: boolean
  isLoading?: boolean
  onClick: () => void
}

const SuccessButton: React.FC<IPopupDialog> = ({
  label,
  disabled,
  isLoading,
  onClick,
}) => {
  const { t } = useTranslation()
  return (
    <Button
      size="small"
      variant="contained"
      color="success"
      disabled={isLoading || disabled}
      startIcon={
        !isLoading ? (
          <CheckIcon />
        ) : (
          <CircularProgress color="inherit" size={20} />
        )
      }
      onClick={onClick}
    >
      {label !== undefined ? label : t('ok')}
    </Button>
  )
}

export default SuccessButton
